// Recovered compiled webpack factory 29691. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { HeroFilm: () => l });
  var n = r(95155),
    a = r(12115),
    s = r(65025);
  let i = { light: 4, dark: 1.4 };
  function l(e) {
    let { src: t, poster: r, label: l } = e,
      h = (function () {
        let [e, t] = (0, a.useState)("light");
        return (
          (0, a.useEffect)(() => {
            let e = document.documentElement,
              r = () => t(e.classList.contains("dark") ? "dark" : "light");
            r();
            let n = new MutationObserver(r);
            return (
              n.observe(e, { attributes: !0, attributeFilter: ["class"] }),
              () => n.disconnect()
            );
          }, []),
          e
        );
      })(),
      p = (0, a.useRef)(null),
      f = (0, a.useRef)(null),
      v = (0, a.useRef)(!1),
      [b, g] = (0, a.useState)(!1),
      [x, y] = (0, a.useState)(!1),
      [w, k] = (0, a.useState)(!1),
      [j, N] = (0, a.useState)(!0),
      [_, E] = (0, a.useState)(!1),
      M = (0, a.useCallback)(() => {
        (N(!0),
          f.current && window.clearTimeout(f.current),
          (f.current = window.setTimeout(() => N(!1), 2600)));
      }, []);
    (0, a.useEffect)(
      () => () => {
        f.current && window.clearTimeout(f.current);
      },
      [],
    );
    let P = (0, a.useCallback)(async () => {
        let e = p.current;
        if (e) {
          (g(!0),
            v.current && ((e.currentTime = 0), (v.current = !1)),
            "none" === e.preload && (e.preload = "auto"));
          try {
            await e.play();
          } catch {
            ((e.muted = !0), k(!0));
            try {
              await e.play();
            } catch {}
          }
          M();
        }
      }, [M]),
      L = (0, a.useCallback)(() => {
        let e = p.current;
        e && (e.paused ? P() : ((v.current = !1), e.pause()));
      }, [P]),
      $ = (0, a.useCallback)(() => {
        let e = p.current;
        e && ((e.muted = !e.muted), k(e.muted), M());
      }, [M]);
    return (0, n.jsxs)("div", {
      className: "group/film relative h-full w-full bg-black",
      onPointerMove: () => b && M(),
      onPointerLeave: () => x && N(!1),
      children: [
        (0, n.jsx)("video", {
          ref: p,
          "data-track-media": "hero_film",
          className: "h-full w-full object-cover",
          src: t,
          "aria-label": l,
          preload: "none",
          playsInline: !0,
          disablePictureInPicture: !0,
          onPlay: () => {
            (y(!0), g(!0));
          },
          onPause: () => y(!1),
          onEnded: (e) => {
            ((e.currentTarget.currentTime = i[h]), (v.current = !0), y(!1));
          },
          onVolumeChange: (e) => k(e.currentTarget.muted),
        }),
        (0, n.jsx)("div", {
          "aria-hidden": !0,
          style: { backgroundImage: `url(${r[h]})` },
          className: `pointer-events-none absolute inset-0 bg-cover bg-center transition-opacity duration-500 ease-out ${b ? "opacity-0" : "opacity-100"}`,
        }),
        b &&
          (0, n.jsx)("button", {
            type: "button",
            onClick: L,
            tabIndex: -1,
            "aria-hidden": !0,
            className: "absolute inset-0 z-0 cursor-default",
          }),
        (0, n.jsx)("div", {
          className: `pointer-events-none absolute inset-0 z-10 flex items-center justify-center transition-opacity duration-300 ease-out ${x ? "opacity-0" : "opacity-100"}`,
          children: (0, n.jsx)("button", {
            type: "button",
            onClick: () => void P(),
            "aria-label": b ? "Resume the film" : "Play the film",
            className:
              "um-glass pointer-events-auto flex h-[76px] w-[76px] items-center justify-center rounded-full text-white active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80 motion-reduce:active:scale-100 sm:h-[96px] sm:w-[96px]",
            children: (0, n.jsx)(c, {
              className:
                "ml-[2px] h-[26px] w-[26px] [filter:drop-shadow(0_1px_2px_rgb(0_0_0/0.3))] sm:h-[32px] sm:w-[32px]",
            }),
          }),
        }),
        (0, n.jsx)("div", {
          className: `pointer-events-none absolute inset-x-0 bottom-0 z-10 flex justify-center p-4 transition-opacity duration-300 ease-out sm:p-6 ${x ? "opacity-0" : "opacity-100"}`,
          children: (0, n.jsx)("span", {
            className: `${s.iP} um-glass um-glass-static rounded-full px-3.5 py-2 text-[11px] uppercase leading-none tracking-[0.08em] text-white`,
            children: "Video made entirely in Mockup Studio",
          }),
        }),
        (0, n.jsx)("div", {
          className: `absolute inset-x-0 bottom-0 z-10 flex justify-center p-4 transition-[opacity,transform] duration-300 ease-out sm:p-6 ${b ? "" : "pointer-events-none"} ${b && (!x || _ || j) ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-2 opacity-0"}`,
          onPointerEnter: () => E(!0),
          onPointerLeave: () => E(!1),
          onFocus: () => E(!0),
          onBlur: () => E(!1),
          children: (0, n.jsxs)("div", {
            className: "um-glass flex items-center gap-0.5 rounded-full p-1 text-white",
            children: [
              (0, n.jsx)(o, {
                side: "left",
                onClick: L,
                label: x ? "Pause the film" : "Resume the film",
                children: x ? (0, n.jsx)(d, {}) : (0, n.jsx)(c, { className: "ml-px h-4 w-4" }),
              }),
              (0, n.jsx)("span", { "aria-hidden": !0, className: "h-5 w-px bg-white/25" }),
              (0, n.jsx)(o, {
                side: "right",
                onClick: $,
                label: w ? "Unmute the film" : "Mute the film",
                pressed: w,
                children: w ? (0, n.jsx)(m, {}) : (0, n.jsx)(u, {}),
              }),
            ],
          }),
        }),
      ],
    });
  }
  function o(e) {
    let { onClick: t, label: r, pressed: a, side: s, children: i } = e;
    return (0, n.jsx)("button", {
      type: "button",
      onClick: t,
      "aria-label": r,
      "aria-pressed": a,
      className: `flex h-10 w-10 items-center justify-center transition-colors duration-150 ease-out hover:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80 ${"left" === s ? "rounded-l-full rounded-r-[4px]" : "rounded-l-[4px] rounded-r-full"}`,
      children: i,
    });
  }
  function c(e) {
    let { className: t = "h-4 w-4" } = e;
    return (0, n.jsx)("svg", {
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": !0,
      className: t,
      children: (0, n.jsx)("path", {
        d: "M5.9 5.2v13.6a1 1 0 0 0 1.53.85l10.2-6.8a1 1 0 0 0 0-1.7L7.43 4.35A1 1 0 0 0 5.9 5.2Z",
        strokeLinejoin: "round",
        strokeWidth: "1.6",
        stroke: "currentColor",
      }),
    });
  }
  function d() {
    return (0, n.jsxs)("svg", {
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": !0,
      className: "h-4 w-4",
      children: [
        (0, n.jsx)("rect", { x: "6.5", y: "5", width: "4", height: "14", rx: "1.4" }),
        (0, n.jsx)("rect", { x: "13.5", y: "5", width: "4", height: "14", rx: "1.4" }),
      ],
    });
  }
  function u() {
    return (0, n.jsxs)("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": !0,
      className: "h-[18px] w-[18px]",
      children: [
        (0, n.jsx)("path", {
          d: "M11 5 6.5 8.8H3.6a.6.6 0 0 0-.6.6v5.2a.6.6 0 0 0 .6.6h2.9L11 19Z",
          fill: "currentColor",
        }),
        (0, n.jsx)("path", { d: "M15.4 9.2a4 4 0 0 1 0 5.6" }),
        (0, n.jsx)("path", { d: "M18.2 6.4a8 8 0 0 1 0 11.2" }),
      ],
    });
  }
  function m() {
    return (0, n.jsxs)("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": !0,
      className: "h-[18px] w-[18px]",
      children: [
        (0, n.jsx)("path", {
          d: "M11 5 6.5 8.8H3.6a.6.6 0 0 0-.6.6v5.2a.6.6 0 0 0 .6.6h2.9L11 19Z",
          fill: "currentColor",
        }),
        (0, n.jsx)("path", { d: "m16 9.5 5 5M21 9.5l-5 5" }),
      ],
    });
  }
}
